import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {DayPicker} from 'react-day-picker';
import WayTripRadios from 'ferries/Home/components/FerrySearchMask/WayTripRadios';
import {removeAccent} from 'helpers/text';

const Content = ({
  showTripTypes, roundTrip, month, selectedDays, fromDate, toDate, locale,
  setRoundTrip, setDayPickerMonth, handleDateClick, translations
}) => {

  useEffect(() => {
    const div = document.createElement('div');
    div.className = 'rdp-today-indication';
    div.innerHTML = removeAccent(translations.today.toUpperCase());

    for (let item of document.getElementsByClassName('rdp-day_today')) {
      item.appendChild(div);
    }
  }, [translations.today, month]);

  return (
    <>
      {showTripTypes && <WayTripRadios
        roundTrip={roundTrip}
        setRoundTrip={setRoundTrip}
        translations={translations}
      />}
      <DayPicker
        mode="range"
        numberOfMonths={2}
        month={month}
        selected={selectedDays}
        fromDate={fromDate}
        toDate={toDate}
        locale={locale}
        onSelect={handleDateClick}
        onMonthChange={setDayPickerMonth}
      />
    </>
  );
};

Content.propTypes = {
  showTripTypes: PropTypes.bool.isRequired,
  roundTrip: PropTypes.bool.isRequired,
  month: PropTypes.object.isRequired,
  selectedDays: PropTypes.object.isRequired,
  fromDate: PropTypes.object.isRequired,
  toDate: PropTypes.object.isRequired,
  locale: PropTypes.object,
  setRoundTrip: PropTypes.func.isRequired,
  setDayPickerMonth: PropTypes.func.isRequired,
  handleDateClick: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(Content);
